import { useDispatch, useSelector } from "react-redux"
import InputGroup from "react-bootstrap/InputGroup"
import Form from "react-bootstrap/Form"
import { teamStatus } from "state_management"
import useT from "utils/hooks/useT"

export default function AssetOverbookingButton() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const assetOverbooking = useSelector((state) => state.teamStatus.assetOverbooked)

  return (
    <InputGroup>
      <Form.Check
        checked={assetOverbooking}
        type={"checkbox"}
        id={`asset-overbooking-checkbox`}
        onChange={(e) => dispatch(teamStatus.overbooking({ assetOverbooking: e.target.checked }))}
      />
      <div className="Include-today">
        <p>{t("instrumentOverbooking")}</p>
      </div>
    </InputGroup>
  )
}
